import {
  Body2,
  Box,
  Caption2,
  Color,
  DisplayPosition,
  FontWeight,
  Body1,
  Image,
  Space,
  useTheme,
  Display,
  FlexDirection,
  AlignItems,
  JustifyContent,
} from '@gousto-internal/citrus-react'
import React from 'react'
import { LandingPageContentSections, trackCTAClick, TrackingActions } from '../../../../tracking'

type SupplierCardOverlay = {
  title: string
  location: string
  since: string
  tag: string | undefined
}

type SupplierCardProps = {
  webpSmall: string
  webpLarge: string
  fallback: string
  alt: string
  supplierDetails: SupplierCardOverlay
}

export function SupplierCard({
  webpSmall,
  webpLarge,
  fallback,
  alt,
  supplierDetails,
}: SupplierCardProps) {
  const { theme } = useTheme()
  const trackClickSuppliers = () => {
    trackCTAClick(
      TrackingActions.OUR_SUPPLIERS_CAROUSEL,
      LandingPageContentSections.OUR_SUPPLIERS,
      {
        supplierDetails: supplierDetails.title,
      },
    )
  }

  return (
    <a
      href="https://www.gousto.co.uk/blog/suppliers"
      style={{ display: 'block', textDecoration: 'none' }}
      onClick={trackClickSuppliers}
    >
      <Box
        maxHeight={['280px', '360px']}
        maxWidth={['210px', '230px']}
        position={DisplayPosition.Relative}
      >
        <picture>
          <source
            srcSet={webpSmall}
            media={`(max-width: ${theme.tokens.breakpoints[1]})`}
            type="image/webp"
          />
          <source
            srcSet={webpLarge}
            media={`(min-width: ${theme.tokens.breakpoints[1]})`}
            type="image/webp"
          />
          <Image
            src={fallback}
            alt={alt}
            width="100%"
            height="100%"
            style={{ objectFit: 'cover' }}
          />
        </picture>
        <Box position={DisplayPosition.Absolute} bottom="0" left="0" right="0" paddingH={4}>
          <Box
            display={Display.Flex}
            flexDirection={FlexDirection.Column}
            alignItems={AlignItems.FlexStart}
            justifyContent={JustifyContent.FlexStart}
          >
            <Body1 color={Color.White} fontWeight={FontWeight.Bold}>
              {supplierDetails.title}
            </Body1>
            <Body2 color={Color.White}>{supplierDetails.location}</Body2>
            <Body2 color={Color.White}>{supplierDetails.since}</Body2>
            <Space size={2} />
            <Box minHeight="20px">
              {supplierDetails.tag ? (
                <Caption2 color={Color.ColdGrey_100}>{supplierDetails.tag}</Caption2>
              ) : null}
            </Box>
            <Space size={4} />
          </Box>
        </Box>
      </Box>
    </a>
  )
}
